import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

export interface ddOption {
  label: string;
  value: any;
  disabled?: boolean;
}

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  @Input() optionsDDL: ddOption[] = [];
  @Input() placeholder: string = '';
  @Input() control: FormControl = new FormControl();
  @Input() disabled: boolean = false;
  @Input() showClear: boolean = true;
  @Input() filter: boolean = true;
  @Input() filterBy: string = 'label';
  @Input() optionLabel: string = 'label';
  @Input() optionValue: string = 'value';
  @Input() ddIcon: string = '';
  @Input() styleClass: string = '';
  
  @Output() onChange = new EventEmitter<any>();
  @Output() onFilter = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {

  }

  onSelectionChange(event: any): void {
    this.onChange.emit(event.value);
  }

  onFilterChange(event: any): void {
    this.onFilter.emit(event);
  }
}
